import "@/App.css";
import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";

if (localStorage.getItem("bpbd_dark") === "1") {
  document.documentElement.classList.add("dark");
}
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { AlertBanner } from "./components/AlertBanner";
import { EmergencyFAB } from "./components/EmergencyFAB";
import { ScrollProgress } from "./components/ScrollProgress";
import { VisitTracker } from "./components/VisitTracker";
import Home from "./pages/Home";
import Profil from "./pages/Profil";
import Bidang from "./pages/Bidang";
import InfoKebencanaan from "./pages/InfoKebencanaan";
import InfoPublik from "./pages/InfoPublik";
import Layanan from "./pages/Layanan";
import Berita from "./pages/Berita";
import BeritaDetail from "./pages/BeritaDetail";
import Kegiatan from "./pages/Kegiatan";
import ProdukHukum from "./pages/ProdukHukum";
import Faq from "./pages/Faq";
import Galeri from "./pages/Galeri";
import Tautan from "./pages/Tautan";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

const PublicLayout = () => (
  <>
    <div className="public-bg" aria-hidden="true" />
    <VisitTracker />
    <ScrollProgress />
    <AlertBanner />
    <Navbar />
    <main className="min-h-[60vh]">
      <Outlet />
    </main>
    <Footer />
    <EmergencyFAB />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/profil" element={<Profil />} />
              <Route path="/bidang" element={<Bidang />} />
              <Route path="/informasi" element={<InfoKebencanaan />} />
              <Route path="/informasi-publik" element={<InfoPublik />} />
              <Route path="/layanan" element={<Layanan />} />
              <Route path="/berita" element={<Berita />} />
              <Route path="/berita/:id" element={<BeritaDetail />} />
              <Route path="/kegiatan" element={<Kegiatan />} />
              <Route path="/produk-hukum" element={<ProdukHukum />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/galeri" element={<Galeri />} />
              <Route path="/tautan" element={<Tautan />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        </ContentProvider>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
